// extracted by mini-css-extract-plugin
export default {"container":"VibeBox_container__-vp6u","button":"VibeBox_button__8XkcQ","spotify_logo":"VibeBox_spotify_logo__WJOC3"};